import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DELIVERIES_PAUSED_IN_PERIOD: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Du har pauset leveransene dine mellom ${firstDateString} og ${lastDateString}. Du vil ikke motta leveranser i denne perioden hvis du ikke bestiller individuelle leveranser.`,
      RESUME_DELIVERIES: "Gjenoppta leveranser",

      DELIVERIES_RESUMED_SUCCESSFULLY: "Leveranser gjenopptatt",
      ERROR_RESUMING_DELIVERIES:
        "Noe gikk galt da vi forsøkte å gjenoppta leveransene dine, ta kontakt med kundeservice",
    },

    dk: {
      DELIVERIES_PAUSED_IN_PERIOD: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Du har sat din levering på pause i perioden ${firstDateString} til ${lastDateString}. Du modtager ingen leveringer i denne periode, med mindre du bestiller enkeltleverancer.`,
      RESUME_DELIVERIES: "Fjern pause",
    },

    se: {
      DELIVERIES_PAUSED_IN_PERIOD: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Du har pausat dina leveranser mellan ${firstDateString} till ${lastDateString}. Du kommer inte att ta emot leveranser under denna period om du inte beställer enskilda leveranser.`,
      RESUME_DELIVERIES: "Återuppta leveranser",
    },
  } as const
)[language];
